import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setUpdatePaymentSystem = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_PAYMENT
            });
            dispatch(Action.SetGetListPaymentSystem({
                search: ''
            }))

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setUpdatePaymentSystem as SetUpdatePaymentSystem
}